// app/javascript/modules/ferias/agendadas_search.js

export function initFeriasAgendadasSearch(rootEl) {
  const input = rootEl.querySelector("#busca_funcionario");
  if (!input) return { destroy() {} };

  function filter() {
    const query = input.value.toLowerCase().trim();
    rootEl.querySelectorAll("tr[id^='funcionario_']").forEach((row) => {
      const nome = (row.querySelector("td")?.textContent ?? "").toLowerCase();
      const match = !query || nome.includes(query);
      const funcId = row.id.replace("funcionario_", "");
      row.style.display = match ? "" : "none";
      if (!match) {
        const histRow = rootEl.querySelector(`#historico_ferias_${funcId}`);
        if (histRow) histRow.style.display = "none";
      }
    });
  }

  input.addEventListener("input", filter);
  return { destroy() { input.removeEventListener("input", filter); } };
}
